module.exports = __webpack_public_path__ + "assets/863da4994752a69e59dfa0ad8a45ba86.svg";